/**
 * Storage Version Management
 *
 * 用于管理localStorage的版本，当检测到版本变化时自动清理旧数据
 * 解决老用户浏览器缓存导致的SSO认证问题
 */

// 当前存储版本（每次OIDC配置变更或存储结构变化时递增）
const CURRENT_STORAGE_VERSION = '2.0.0';
const STORAGE_VERSION_KEY = 'moss_storage_version';

/**
 * 检查并清理过期的存储数据
 *
 * ✅ 优化：版本变更时不再清理有效 Token
 * 原因：版本变更（如部署新版本）不应导致用户被登出
 * 新策略：只更新版本号，清理已知的无效数据结构，保留有效的 Token
 *
 * @returns {boolean} 是否执行了清理
 */
export const checkAndCleanStorage = (): boolean => {
  const storedVersion = localStorage.getItem(STORAGE_VERSION_KEY);

  // 如果版本不匹配，只更新版本号，不清理 Token
  if (storedVersion !== CURRENT_STORAGE_VERSION) {
    console.log('[storageUtils] 检测到版本变更:', storedVersion, '->', CURRENT_STORAGE_VERSION);

    // ✅ 修复：不再调用 cleanAllAuthStorage()
    // 只清理可能存在的旧版本数据结构（已废弃的字段）
    const deprecatedKeys = [
      'old_token_format',  // 示例：旧版本可能存在的字段
      'legacy_user_data',
    ];
    deprecatedKeys.forEach(key => {
      if (localStorage.getItem(key)) {
        localStorage.removeItem(key);
        console.log('[storageUtils] 清理废弃字段:', key);
      }
    });

    // 更新版本号
    localStorage.setItem(STORAGE_VERSION_KEY, CURRENT_STORAGE_VERSION);

    return true;
  }

  return false;
};

/**
 * 清理所有认证相关的存储数据
 *
 * 包括：
 * - access_token
 * - id_token
 * - tokenObj
 * - uid
 * - 所有 oidc.* 前缀的数据
 * - auth-storage (Zustand持久化)
 */
export const cleanAllAuthStorage = (): void => {


  // 1. 清理明确的token字段
  const explicitKeys = ['access_token', 'id_token', 'tokenObj', 'uid', 'auth-storage'];
  explicitKeys.forEach(key => {
    if (localStorage.getItem(key)) {
      localStorage.removeItem(key);

    }
  });

  // 2. 清理所有 oidc.* 前缀的数据
  const allKeys = Object.keys(localStorage);
  const oidcKeys = allKeys.filter(key => key.startsWith('oidc.'));


  oidcKeys.forEach(key => {
    localStorage.removeItem(key);

  });

  // 3. 同时清理sessionStorage中的OIDC数据
  const sessionKeys = Object.keys(sessionStorage);
  const sessionOidcKeys = sessionKeys.filter(key => key.startsWith('oidc.'));
  sessionOidcKeys.forEach(key => {
    sessionStorage.removeItem(key);

  });


};

/**
 * 强制清理并刷新页面
 *
 * 用于"清除缓存重试"按钮
 */
export const forceCleanAndReload = (): void => {

  cleanAllAuthStorage();
  localStorage.removeItem(STORAGE_VERSION_KEY); // 移除版本标记，下次重新检查

  // 延迟刷新，确保用户能看到操作反馈
  setTimeout(() => {
    window.location.href = window.location.origin;
  }, 500);
};

/**
 * 获取当前所有OIDC相关存储信息（用于调试）
 */
export const debugAuthStorage = (): void => {







  const oidcKeys = Object.keys(localStorage).filter(key => key.startsWith('oidc.'));
  void oidcKeys;



};
